export type TTransactionsListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
  from: string;
  to: string;
};

export type TTransactionCodesListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
};

export const transactionsKeys = {
  all: [{ module: 'transactions' }] as const,
  lists: () => [{ ...transactionsKeys.all[0], scope: 'list' }] as const,
  list: (params: TTransactionsListParams) => [{ ...transactionsKeys.lists()[0], params }] as const,
  codeLists: () => [{ ...transactionsKeys.all[0], scope: 'codeList' }] as const,
  codeList: (params: TTransactionCodesListParams) => [{ ...transactionsKeys.codeLists()[0], params }] as const,
  codeDetails: () => [{ ...transactionsKeys.all[0], scope: 'codeDetail' }] as const,
  codeDetail: (code: string) => [{ ...transactionsKeys.codeDetails()[0], code }] as const,
};
